module.exports = __webpack_public_path__ + "img/lf7.5f0611e3.png";